import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './styles/theme'; // Asegúrate de que el archivo theme esté correctamente configurado
import App from './App';
import './index.css'; // Importa el archivo CSS global aquí
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
